__turbopack_context__.v({
  "ctaContainer": "tM_jfW_ctaContainer",
  "description": "tM_jfW_description",
  "disclaimer": "tM_jfW_disclaimer",
  "imgContainer": "tM_jfW_imgContainer",
  "imgTextContainer": "tM_jfW_imgTextContainer",
  "linkModalContent": "tM_jfW_linkModalContent",
  "root": "tM_jfW_root",
  "textContainer": "tM_jfW_textContainer",
  "vidContainer": "tM_jfW_vidContainer",
});
